var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgA5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_621",
    "data-name": "Group 621",
    transform: "translate(-804 -1847)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_126",
    "data-name": "Rectangle 126",
    transform: "translate(804 1847)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 93,
    height: 93,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 92,
    height: 92,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "rhythm",
    transform: "translate(769 1815)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_225",
    "data-name": "Group 225",
    transform: "translate(40 55.973)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_217",
    "data-name": "Group 217",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_442",
    "data-name": "Path 442",
    d: "M122.964,186.091H40V146.145A6.145,6.145,0,0,1,46.145,140h70.673a6.145,6.145,0,0,1,6.145,6.145Z",
    transform: "translate(-40 -140)",
    fill: "#463c4b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_218",
    "data-name": "Group 218",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_443",
    "data-name": "Path 443",
    d: "M116.818,186.091H40V146.145A6.145,6.145,0,0,1,46.145,140h64.527a6.145,6.145,0,0,1,6.145,6.145Z",
    transform: "translate(-40 -140)",
    fill: "#555a6e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_219",
    "data-name": "Group 219",
    transform: "translate(0 46.091)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_444",
    "data-name": "Path 444",
    d: "M46.145,387.682h70.673a6.145,6.145,0,0,0,6.145-6.145V380H40v1.536A6.145,6.145,0,0,0,46.145,387.682Z",
    transform: "translate(-40 -380)",
    fill: "#a5c3dc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_220",
    "data-name": "Group 220",
    transform: "translate(0 46.091)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_445",
    "data-name": "Path 445",
    d: "M110.673,387.682H46.145A6.145,6.145,0,0,1,40,381.536V380h76.818v1.536A6.145,6.145,0,0,1,110.673,387.682Z",
    transform: "translate(-40 -380)",
    fill: "#d7e6f0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_221",
    "data-name": "Group 221",
    transform: "translate(32.264 53.773)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_446",
    "data-name": "Path 446",
    d: "M208,420h13.827v6.145H208Z",
    transform: "translate(-208 -420)",
    fill: "#a5c3dc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_222",
    "data-name": "Group 222",
    transform: "translate(32.264 56.845)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_447",
    "data-name": "Path 447",
    d: "M208,436h9.218v3.073H208Z",
    transform: "translate(-208 -436)",
    fill: "#d7e6f0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_223",
    "data-name": "Group 223",
    transform: "translate(23.045 59.918)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_448",
    "data-name": "Path 448",
    d: "M190.727,456.609H160v-1.536A3.073,3.073,0,0,1,163.073,452h24.582a3.073,3.073,0,0,1,3.073,3.073Z",
    transform: "translate(-160 -452)",
    fill: "#d7e6f0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_224",
    "data-name": "Group 224",
    transform: "translate(44.555 59.918)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_449",
    "data-name": "Path 449",
    d: "M281.218,456.609H272v-1.536A3.073,3.073,0,0,1,275.073,452h3.073a3.073,3.073,0,0,1,3.073,3.073Z",
    transform: "translate(-272 -452)",
    fill: "#a5c3dc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_226",
    "data-name": "Group 226",
    transform: "translate(49.218 36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_450",
    "data-name": "Path 450",
    d: "M143.309,92.845H91.073A3.073,3.073,0,0,1,88,89.773v-50.7A3.073,3.073,0,0,1,91.073,36h52.236a3.073,3.073,0,0,1,3.073,3.073v50.7A3.073,3.073,0,0,1,143.309,92.845Z",
    transform: "translate(-88 -36)",
    fill: "#d7e6f0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_227",
    "data-name": "Group 227",
    transform: "translate(49.218 36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_451",
    "data-name": "Path 451",
    d: "M146.382,42.145H88V39.073A3.073,3.073,0,0,1,91.073,36h52.236a3.073,3.073,0,0,1,3.073,3.073Z",
    transform: "translate(-88 -36)",
    fill: "#555a6e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_228",
    "data-name": "Group 228",
    transform: "translate(53.954 37.55)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_27",
    "data-name": "Ellipse 27",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(0.046 0.45)",
    fill: "#289bc3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_229",
    "data-name": "Group 229",
    transform: "translate(60.156 37.55)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_28",
    "data-name": "Ellipse 28",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(-0.156 0.45)",
    fill: "#ff6e91"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_230",
    "data-name": "Group 230",
    transform: "translate(66.358 37.55)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_29",
    "data-name": "Ellipse 29",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(-0.358 0.45)",
    fill: "#d7e6f0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_231",
    "data-name": "Group 231",
    transform: "translate(64.582 45.218)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_452",
    "data-name": "Path 452",
    d: "M194.118,87.073H169.536a1.536,1.536,0,0,1,0-3.073h24.582a1.536,1.536,0,0,1,0,3.073Z",
    transform: "translate(-168 -84)",
    fill: "#00d2d2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_232",
    "data-name": "Group 232",
    transform: "translate(58.436 63.655)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_453",
    "data-name": "Path 453",
    d: "M174.409,183.073H137.536a1.536,1.536,0,1,1,0-3.073h36.873a1.536,1.536,0,1,1,0,3.073Z",
    transform: "translate(-136 -180)",
    fill: "#ff6e91"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_233",
    "data-name": "Group 233",
    transform: "translate(58.436 72.873)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_454",
    "data-name": "Path 454",
    d: "M174.409,231.073H137.536a1.536,1.536,0,0,1,0-3.073h36.873a1.536,1.536,0,1,1,0,3.073Z",
    transform: "translate(-136 -228)",
    fill: "#ff6e91"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_234",
    "data-name": "Group 234",
    transform: "translate(58.436 82.091)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_455",
    "data-name": "Path 455",
    d: "M174.409,279.073H137.536a1.536,1.536,0,0,1,0-3.073h36.873a1.536,1.536,0,0,1,0,3.073Z",
    transform: "translate(-136 -276)",
    fill: "#ff6e91"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_235",
    "data-name": "Group 235",
    transform: "translate(49.218 50.595)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_456",
    "data-name": "Path 456",
    d: "M88,112h58.382v1.536H88Z",
    transform: "translate(-88 -112)",
    fill: "#a5c3dc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_236",
    "data-name": "Group 236",
    transform: "translate(49.218 59.814)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_457",
    "data-name": "Path 457",
    d: "M88,160h58.382v1.536H88Z",
    transform: "translate(-88 -160)",
    fill: "#a5c3dc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_237",
    "data-name": "Group 237",
    transform: "translate(49.218 69.032)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_458",
    "data-name": "Path 458",
    d: "M88,208h58.382v1.536H88Z",
    transform: "translate(-88 -208)",
    fill: "#a5c3dc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_238",
    "data-name": "Group 238",
    transform: "translate(49.218 78.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_459",
    "data-name": "Path 459",
    d: "M88,256h58.382v1.536H88Z",
    transform: "translate(-88 -256)",
    fill: "#a5c3dc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_239",
    "data-name": "Group 239",
    transform: "translate(49.218 87.468)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_460",
    "data-name": "Path 460",
    d: "M88,304h58.382v1.536H88Z",
    transform: "translate(-88 -304)",
    fill: "#a5c3dc"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgA5);
export default __webpack_public_path__ + "static/media/a5.f410696af96e0d0b2239a989b6d66992.svg";
export { ForwardRef as ReactComponent };